import React, { memo } from 'react';
import { IMaskInput } from 'react-imask';
import { FormWrapper, InputWrapper } from './Wrappers';

export function isValidOcr(ocrNumber: string | null) {
  return ocrNumber !== null && ocrNumber != ''
}

function OcrInputIMask({onChange, ...props}: {onChange?: (newValue: string) => void}) {
  return (
    <IMaskInput
      {...props}
      mask={/^\d+$/}
      unmask={false}
      onAccept={(value, _mask, event) => {if (event !== undefined && onChange !== undefined) { onChange(value) }}}
    />
  )
}

const OcrInput = memo(FormWrapper({Component: InputWrapper(OcrInputIMask), validationFunction: isValidOcr}))

export default OcrInput
